import { csx } from '@vtex/admin-ui'

const styles = {
  radioGroupLabel: csx({
    paddingBottom: '$space-1',
  }),
}

export default styles
